var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center"},[_vm._l((_vm.params.value),function(data){return [_c('div',[_c('li',[_vm._v("data.title")]),_c('br')])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }